import { useAsyncExecutor } from "async-executor-hook";
import { getErrorValueResponse } from "../../common/error/Error";

import LoadingSpinner from "../../images/icon_loading_green.gif";
import { HTTP_METHODS } from "../../utils/constants";
import { networkBackendRequest } from "../../utils/networkUtils";
import Modal from "../Modal/Modal";
import { Container, MainButton } from "./AdminAskForActionStyles";

const AdminAskForActionNotification = (props) => {
  const {
    toggleModal,
    titleMessage,
    bodyMessage,
    buttonMessage,
    sidebarInfoData,
    setShowModalSuccessErrorNotification,
    setMessageModalSuccessErrorNotification,
    setTitleModalSuccessErrorNotification,
    setOperationSuccess,
    toggleSucces,
  } = props;
  const updateAskForActionNotification = useAsyncExecutor(
    (params: any) => {
      const url_endpoint =
        params.sidebarInfoData.sidebar_details.patch_info.endpoint;
      const notification_type = params.sidebarInfoData.notification_type;
      if (notification_type === "senasa") {
        const params_senasa = {
          senasa_status_option: "approved",
        };
        return networkBackendRequest(
          url_endpoint,
          HTTP_METHODS.PATCH,
          null,
          params_senasa
        ).then((resp) => resp.json());
      }

      if (notification_type === "electronic_mandate") {
        const params_electronic_mandate = {
          electronic_mandate_status_option: "approved",
        };
        return networkBackendRequest(
          url_endpoint,
          HTTP_METHODS.PATCH,
          null,
          params_electronic_mandate
        ).then((resp) => resp.json());
      }
      if (notification_type === "third_party_billing_authorization") {
        const params_third_party_billing = {
          third_party_billing_authorization_status_option: "approved",
        };
        return networkBackendRequest(
          url_endpoint,
          HTTP_METHODS.PATCH,
          null,
          params_third_party_billing
        ).then((resp) => resp.json());
      }
    },
    {
      onSuccess: () => {
        setTitleModalSuccessErrorNotification("Documento validado");
        setMessageModalSuccessErrorNotification(
          "Se ha validado el documento correctamente."
        );
        setShowModalSuccessErrorNotification(true);
        setOperationSuccess(true);
        toggleSucces();
      },
      onError: (error) => {
        const errorMessage = getErrorValueResponse(error);
        setTitleModalSuccessErrorNotification("Atención");
        setMessageModalSuccessErrorNotification(errorMessage);
        setShowModalSuccessErrorNotification(true);
        toggleModal();
      },
    }
  );

  return (
    <Modal
      onOutsideClick={() => {
        toggleModal();
      }}
    >
      <Container>
        <h1>{titleMessage}</h1>
        <p>{bodyMessage}</p>
        <MainButton
          onClick={() => {
            updateAskForActionNotification.execute({ sidebarInfoData });
          }}
          disabled={updateAskForActionNotification.isLoading}
        >
          {updateAskForActionNotification.isLoading && (
            <img className="icon" src={LoadingSpinner} alt="spinner" />
          )}
          {buttonMessage}
        </MainButton>
      </Container>
    </Modal>
  );
};

export default AdminAskForActionNotification;
